import { useMemo } from 'react';
import { useDeprecate } from '@adsk/alloy-react-helpers';
/**
 * renderLeftElement and renderRightElement will be the only options after a breaking change.
 * At that point we can remove this hook entirely
 */
export default _ref => {
  let {
    renderIcon,
    renderRightElement,
    renderLeftIcon,
    renderLeftElement
  } = _ref;
  useDeprecate(!!renderIcon, 'TextInput', 'renderIcon', 'renderRightElement');
  useDeprecate(!!renderLeftIcon, 'TextInput', 'renderLeftIcon', 'renderLeftElement');
  const renderLeft = useMemo(() => renderLeftElement || renderLeftIcon, [renderLeftElement, renderLeftIcon]);
  const renderRight = useMemo(() => renderRightElement || renderIcon, [renderIcon, renderRightElement]);
  return {
    renderLeft,
    renderRight
  };
};
//# sourceMappingURL=useDeprecatedRenderProps.js.map